import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNotification } from 'components/Notification'
import { deleteUserFdsadminDetail } from 'services/users'
import { USER_QUERY_KEY } from 'pages/Users/hooks/useUsers'

/**
 * Mutation hook for deleting a user's FDS admin detail record.
 * @param {string} userId - the ID of the user whose detail is being deleted (used to invalidate the user cache)
 * @returns {{ deleteDetail: Function, isDeleting: boolean }} deleteDetail accepts the user_fdsadmin_details record ID
 */
function useDeleteUserFdsadminDetail(userId) {
  const { createNotification } = useNotification()
  const queryClient = useQueryClient()

  const { mutate: deleteDetail, isPending: isDeleting } = useMutation({
    mutationFn: deleteUserFdsadminDetail,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USER_QUERY_KEY, userId] })
      createNotification({
        message: 'Serial number deleted successfully',
        variant: 'success',
      })
    },
    onError: error => {
      const message =
        error?.response?.data?.errors?.[0]?.message ||
        error?.response?.data?.errors?.[0] ||
        error?.message ||
        'Failed to delete serial number'
      createNotification({ message, variant: 'error' })
    },
  })

  return { deleteDetail, isDeleting }
}

export default useDeleteUserFdsadminDetail
